import {
  GavelIcon,
  FactoryIcon,
  LandmarkIcon,
  ShieldCheckIcon,
  SplitIcon,
  GraduationCapIcon,
} from 'lucide-react'
import type { Competency } from '../types/profile'

export const competencies: Competency[] = [
  {
    title: 'Board Leadership & Governance',
    detail: 'Chair, Remuneration Committee, Audit & Risk',
    icon: GavelIcon,
  },
  {
    title: 'Industrial Transformation & Net Zero',
    detail: 'Decarbonisation pathways and green steel',
    icon: FactoryIcon,
  },
  {
    title: 'Public–Private Partnerships',
    detail: 'Government relations and sovereign programmes',
    icon: LandmarkIcon,
  },
  {
    title: 'Advanced Manufacturing & Defence',
    detail: 'Sovereign capability and supply chain resilience',
    icon: ShieldCheckIcon,
  },
  {
    title: 'Restructuring, M&A Oversight',
    detail: 'Transaction readiness and post-deal integration',
    icon: SplitIcon,
  },
  {
    title: 'STEM & Innovation Ecosystems',
    detail: 'Future workforce and research commercialisation',
    icon: GraduationCapIcon,
  },
]
